<template>
  <div class="py-4 container-fluid">

    <div class="col-12 pb-0  mb-2">
        <div class="card shadow-lg  card-profile-top">
          <div class="card shadow-lg card-border ">
            <div class="card-body p-3">
              <div class="row gx-4">
                <div class="col-auto">

                </div>
                <div class="col-auto my-auto">
                  <div class="h-100"><h5 class="mb-1">Rota de Entrega</h5><p class="mb-0 font-weight-bold text-sm">Pedidos a serem entregues</p>
                </div>
              </div>
              <div class="mx-auto mt-3 col-lg-7 col-md-7 col-sm-7  my-sm-auto ms-sm-auto me-sm-0">
                <div class="nav-wrapper position-relative end-0">
                  <ul class="p-1 bg-transparent nav nav-pills nav-fill" role="tablist">
                    <li class="nav-item col-lg-5 col-md-5 col-sm-5  my-auto">
                      
                  
              
                        <select v-model="id_operacao" @change="getRotasOperacao(id_operacao)" class="form-select form-select-lg" aria-label=".form-select-lg example">
                          <option v-for="item in operacoes" :key="item.id" :value="item.id">
                          {{ item.name }}
                        </option>
                        </select>

                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="sincronizar.show">
          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.show">

            <div class="d-flex flex-column d-flex align-items-center ">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
            </div>
            
          </div>

          <div class="col-12 pb-5 card-header mb-5" v-if="sincronizar.success && !sincronizar.show">

            <div class="alert alert-success d-flex align-items-center" role="alert">
              <i class="fas fa-check-circle text-success me-2"></i>
              <span>Operação realizada com sucesso!</span>
            </div>

          </div>


        </div>
    </div>


    <div class=" row">
      <div class="col-12">
        <rotas-timeline :rotas="rotas" :map="map" />
        <div v-if="rotas.length==0" class="alert alert-white d-flex align-items-center" role="alert">
          <i class="fas fa-info-circle text-info me-2"></i>
          <span>Nenhuma rota encontrada</span>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
   .custom-marker {
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      border: 2px solid black;
      width: 50px;
      height: 50px;
    }

    .custom-marker img {
      width: 100%;
      border-radius: 50%;
    }

    .card-border {
      border: 1px solid gray;
    }

</style>
<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { defineComponent, ref } from 'vue';

import RotasTimeline from "./components/RotasTimeLine.vue";

import ArgonButton from "@/components/ArgonButton.vue";

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    RotasTimeline,
    ArgonButton
  },
  data() {
    return {
      map: null,
      google: null,
      rotas: [],
      operacoes:[],
      current_page:0,
      total_pages:0,
      id_operacao:1,
      sincronizar:{}
    };
  },
  async mounted() {
    
    this.getOperacoes()

  },
  methods: {

    getOperacoes() {

      
      fintailapi
      .get(`/operacoes/rotas`)
      .then((response) => {

        this.operacoes = response.data.rows
        this.id_operacao = this.operacoes[0]
        this.getRotasOperacao(this.operacoes[0].id)

      })
      .catch((error) => {

      })

    },
    getRota(id) {

      fintailapi
      .get(`/rotas/${id}`)
      .then((response) => {

          const colors = ['#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF']; // Exemplo de cores

          this.current_page = 0;

          let rota = response.data;
          this.total_pages = response.data.count / 10

      })
      .catch((error) => {

        //this.isOpenRef = true;

      })

    },
    getRotas() {

        fintailapi
        .get(`/rotas`)
        .then(async(response) => {

           

            this.current_page = 0;

            this.rotas = response.data;
            this.total_pages = response.data.count / 10

          
            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;

            for(let rota of this.rotas){

              this.rotas[key].color = colors[key % colors.length]

          
                key++

            }
         



        })
        .catch((error) => {
          console.log(error)
          //this.isOpenRef = true;

        })

    },
    getRotasOperacao(id_operacao) {

      fintailapi
      .get(`/rotas/operacao/${id_operacao}`)
      .then(async(response) => {

        

          this.current_page = 0;

          this.rotas = response.data;
          this.total_pages = response.data.count / 10

        
          const colors = [
            '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
            '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
            '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
            '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
            '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
            '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
            '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
          ];
          
          let key = 0;

          for(let rota of this.rotas){

            this.rotas[key].color = colors[key % colors.length]

        
              key++

          }
      



      })
      .catch((error) => {
        console.log(error)
        //this.isOpenRef = true;

      })

      },
  },
  
  created() {

  },

});


</script>
